<template>
  <div id="reservation-form-wrapper" v-bind:style="{top: reservationData.top}">
    <div class="close" v-on:click="closeForm"></div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field
              v-model="reservationData.courtname"
              :label="$t('Court')"
              disabled
              required
              validate-on-blur>
            </v-text-field>
          </v-flex>

          <v-flex xs6>
            <v-text-field
              v-model="moment(reservationData.date).format('DD/MM/YYYY')"
              :rules="nameRules"
              :label="$t('Date')"
              :readonly="true"
              disabled
              required
              validate-on-blur>
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="reservationData.starttime"
              :label="$t('Start time')"
              disabled
              required
              validate-on-blur>
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <div class="select-wrapper" data-app>
              <v-select
                v-model="reservationData.endtime"
                :items="reservationData.duration"
                :label="$t('End time')"
                :rules="[(v) => !!v || $t('Select end time')]"
                required
                validate-on-blur
                v-on:change="getPrice">
              </v-select>
            </div>
          </v-flex>
          <v-flex sm6 xs12>
            <v-text-field
              v-model="clientData.firstName"
              :label="$t('Firstname')"
              :rules="nameRules"
              required
              validate-on-blur>
            </v-text-field>
          </v-flex>
          <v-flex sm6 xs12>
            <v-text-field
              v-model="clientData.lastName"
              :label="$t('Lastname')"
              :rules="nameRules"
              required
              validate-on-blur>
            </v-text-field>
          </v-flex>
          <v-flex sm6 xs12>
            <v-text-field
              v-model="clientData.email"
              :rules="emailRules"
              :label="$t('E-mail')"
              required
              validate-on-blur>
            </v-text-field>
          </v-flex>
          <v-flex sm6 xs12>
            <v-text-field
              v-model="clientData.phone"
              :rules="phoneRules"
              :label="$t('Phone')"
              required
              validate-on-blur>
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              name="comment"
              id="comment"
              v-model="reservationData.comment"
              :placeholder="$t('Comment')"
              :rows="2"
              validate-on-blur>
            </v-textarea>
          </v-flex>
          <v-flex xs12>
            <div class="terms">
              <v-checkbox :rules="termsRules" required>
                <template v-slot:label>
                  <div>
                    {{ $t('Agree') }}
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <router-link :to="{ name: 'tingimused'}" target="_blank" @click.stop v-on="on">
                          &nbsp;{{ $t('terms and conditions') }}
                        </router-link>
                      </template>
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </div>
            <div class="errors-wrapper" v-show="errors">{{ errors }}</div>
          </v-flex>
          <v-flex xs12>
            <span class="price" v-show="price != 0"><span>{{ $t('Price total') }}:</span> {{ price }} €</span>
          </v-flex>
          <v-flex xs12>
            <div class="button-wrapper">
              <v-btn :disabled="!valid" color="success" @click="validate">{{ $t('Pay') }}</v-btn>
              <a href="#" class="login-btn" v-if="!isLoggedIn">{{ $t('login') }}</a>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
  props: ["reservationData"],
  data() {
    return {
      valid: true,
      errors: false,
      bookingData: false,
      price: 0,
      termsRules: [
        v => !!v || this.$t('Required field'),
      ],
      nameRules: [
        v => !!v || this.$t('Required field'),
        v => (v && v.length >= 2) || this.$t('Must be at least 2 characters')
      ],
      emailRules: [
        v => !!v || this.$t('Required field'),
        v => /.+@.+/.test(v) || this.$t('E-mail must be valid')
      ],
      phoneRules: [
        v => !!v || this.$t('Required field'),
        v => (v && v.length >= 5) || this.$t('Must be at least 5 numbers')
      ],
      clientData: []
    }
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    moment,
    validate() {
      // alert('The booking process is disabled for a while')
      // return
      if (this.$refs.form.validate()) {
        this.redirectToPayments();
      }
    },
    redirectToPayments: function () {
      this.bookingData = {
        "firstName": this.clientData.firstName,
        "lastName": this.clientData.lastName,
        "email": this.clientData.email,
        "phone": this.clientData.phone,
        "comment": this.reservationData.comment,
        "bookings": [
          {
            "court": this.reservationData.courtname,
            "date": moment(this.reservationData.date).format('YYYY-MM-DD'),
            "startTime": this.reservationData.starttime,
            "endTime": this.reservationData.endtime,
            "price": false
          }
        ]
      }
      //this.getPrice();
      this.startBooking();
    },
    closeForm: function () {
      this.price = 0;
      this.errors = false;
      this.$refs.form.resetValidation();
      this.reservationData.reservationFormVisible = false;
    },
    getClientAccountData: function () {
      if (this.$store.getters.isLoggedIn) {
        axios.get('/getClientAccountData')
          .then(response => {
            if (response.data.success) {
              this.clientData = response.data.data;
            }
          })
          .catch(e => {
            if (e.response.status === 401) {
              localStorage.removeItem('token');
              this.$router.go(0)
            }
            //this.errors.push(e)
          });
      }
    },
    getPrice: function () {
      this.bookingData = {
        "firstName": this.clientData.firstName,
        "lastName": this.clientData.lastName,
        "email": this.clientData.email,
        "phone": this.clientData.phone,
        "comment": this.reservationData.comment,
        "bookings": [
          {
            "court": this.reservationData.courtname,
            "date": moment(this.reservationData.date).format('YYYY-MM-DD'),
            "startTime": this.reservationData.starttime,
            "endTime": this.reservationData.endtime,
            "price": false
          }
        ]
      }
      axios.post('/getBookingPricing', this.bookingData)
        .then(response => {
          if (response.data.success) {
            this.price = response.data.data.price;
          }
        })
        .catch(e => {
          if (e.response.status === 401) {
            localStorage.removeItem('token');
            this.$router.go(0)
          }
          //this.errors.push(e)
        });
    },
    startBooking: function () {
      if (this.bookingData.bookings.price === false) {
        this.errors = this.$t('Error calculating price');
        return false;
      }
      axios.post('/startBooking', this.bookingData).then(response => {
        if (response.data.success) {
          let bookingId = response.data.data;
          this.reservationData.reservationFormVisible = false;
          let paymentGateWayURL = this.$apiURL + '/redirectCalendarPayment';
          let data = {
            "bookingId": bookingId,
            "firstName": this.bookingData.firstName,
            "lastName": this.bookingData.lastName,
            "email": this.bookingData.email,
            "phone": this.bookingData.phone,
            "comment": this.bookingData.comment,
            "court": this.bookingData.bookings[0].court,
            "date": this.bookingData.bookings[0].date,
            "startTime": this.bookingData.bookings[0].startTime,
            "endTime": this.bookingData.bookings[0].endTime,
          }

          let paymentURL = paymentGateWayURL + this.objectToQuerystring(data);
          //redirect to payment page
          window.location.replace(paymentURL);
        }
      }).catch(e => {
        this.errors = e.response.data.message;
        if (e.response.status === 401) {
          localStorage.removeItem('token');
          this.$router.go(0)
        }
      });
    },
    objectToQuerystring: function (obj) {
      return Object.keys(obj).reduce(function (str, key, i) {
        var delimiter, val;
        delimiter = (i === 0) ? '?' : '&';
        key = encodeURIComponent(key);
        val = encodeURIComponent(obj[key]);
        return [str, delimiter, key, '=', val].join('');
      }, '');
    }
  },
  created: function () {
    this.getClientAccountData();
  }
}
</script>

<style lang="scss" scoped>
#reservation-form-wrapper {
  background: #fff;
  max-width: 700px;
  width: 100%;
  margin: 0 auto;
  position: absolute;
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);
  padding: 40px 30px 20px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.25);
  @media only screen and (max-width: 520px) {
    padding: 40px 0 20px;
    .v-text-field {
      padding-top: 0;
    }
  }

  .row {
    display: flex;
    padding: 5px 0;

    label {
      flex: 1 1 30%;
      text-align: right;
      line-height: 38px;
      padding-right: 10px;
      font-size: 0.9rem;
      white-space: nowrap;
    }

    input,
    textarea {
      flex: 1 1 70%;
      height: 38px;
      font-size: 1rem;

      &[type="text"],
      &[type="email"] {
        padding: 0 10px;
      }
    }

    textarea {
      height: 100px;
    }

    select {
      flex: 1 1 70%;
      height: 38px;
      font-size: 1rem;
    }
  }

  .close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;

    &::before {
      width: 3px;
      height: 30px;
      background: #000;
      content: '';
      display: inline-block;
      transform: rotate(45deg);
      position: absolute;
      right: 13px;
    }

    &::after {
      width: 3px;
      height: 30px;
      background: #000;
      content: '';
      display: inline-block;
      transform: rotate(-45deg);
      position: absolute;
      right: 13px;
    }

    &:hover {
      opacity: 0.8;
    }
  }

  .button-wrapper {
    button, a {
      margin: 0 10px;
    }
  }

  .price {
    font-weight: 600;
    font-size: 24px;

    span {
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/calendar/ReservationForm.vue